import React from "react";
import "./ScannedDoubtItem.scss";
const ScannedDoubtItem = ({
  index,
  element,
  handClick,
  convertDate,
  renderQuestion,
}) => {
  return (
    <div
      key={index}
      className="single_doubt_wrappr"
      onClick={() => handClick(element)}
    >
      <div className="single_doubt_innr-wrppr">
        <div className="doubt_date">
          {`Posted at ${convertDate(element.post_date)}`}
        </div>
        <div className="doubt">{renderQuestion(element.question)}</div>
        <div className="view_scanned_doubt">View Scanned Answer</div>
      </div>
    </div>
  );
};

export default ScannedDoubtItem;
